import { Link } from 'react-router-dom';
import { Button, Card, Badge } from '@kss/ui';
import { Rocket, Sparkles, Layers, Shield } from 'lucide-react';

export default function Home() {
  return (
    <div>
      <section className="mx-auto max-w-7xl px-6 pb-16 pt-20 text-center">
        <Badge variant="info" className="mb-4">
          <Sparkles className="h-3 w-3" /> New — KSS Monorepo v1.0
        </Badge>
        <h1 className="mx-auto max-w-3xl text-4xl font-extrabold tracking-tight text-[var(--color-text-primary)] sm:text-6xl">
          The modular admin platform built for modern teams
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base text-[var(--color-text-secondary)] sm:text-lg">
          One codebase. Two apps. Six shared packages. Ship marketing pages and a full admin panel from a single npm workspaces repo.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/demo">
            <Button size="lg">
              <Rocket className="h-4 w-4" /> Try the Demo
            </Button>
          </Link>
          <Link to="/sample">
            <Button size="lg" variant="outline">
              View Components
            </Button>
          </Link>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-20">
        <div className="grid gap-4 md:grid-cols-3">
          <Card title="Monorepo architecture">
            <div className="flex items-start gap-3">
              <Layers className="h-6 w-6 text-[var(--color-primary)]" />
              <p className="text-sm text-[var(--color-text-secondary)]">
                Apps and packages powered by npm workspaces. Import anywhere with <code>@kss/*</code>.
              </p>
            </div>
          </Card>
          <Card title="56+ UI components">
            <div className="flex items-start gap-3">
              <Sparkles className="h-6 w-6 text-[var(--color-primary)]" />
              <p className="text-sm text-[var(--color-text-secondary)]">
                Buttons, forms, cards, charts, widgets and more. All themeable, all TypeScript.
              </p>
            </div>
          </Card>
          <Card title="Data at scale">
            <div className="flex items-start gap-3">
              <Shield className="h-6 w-6 text-[var(--color-primary)]" />
              <p className="text-sm text-[var(--color-text-secondary)]">
                Mantine DataGrid with column filtering, sorting, pagination, and a full React Spreadsheet.
              </p>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
}
